var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.likeCount > 0)?_c('a',{staticClass:"likers-number",style:(_vm.style),on:{"click":_vm.display}},[_c('i',{staticClass:"far fa-thumbs-up"}),_vm._v("\n  "+_vm._s(_vm.likeCount)+"\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }